import * as Types from '../../../_generated/types.d';

import { GeocodeResponseData } from "@googlemaps/google-maps-services-js";
import { CoachState } from "@portal/app/_common/lib/coach";
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
export type FormFunnelQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
}>;


export type FormFunnelQuery = { __typename?: 'Query', getFormFunnelConfig: { __typename?: 'FormFunnel', id: string, slug: string, name: string, meta: { __typename?: 'FormFunnelMeta', title: string | null, description: string | null } | null, questions: Array<{ __typename?: 'FormQuestion', id: string, slug: string, label: string, type: string, required: boolean | null, conditionalLogic: {
        [key: string]: any;
      } | null, options: Array<{ __typename?: 'FormOption', label: string, value: string, icon: string | null }> | null }> } | null };

export type GetFormFunnelMatchesQueryVariables = Types.Exact<{
  funnelId: Types.Scalars['ID']['input'];
  answers: Types.Scalars['Json']['input'];
  geo: Types.DreamSearchGeo;
  jornayaLeadId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  contactData?: Types.InputMaybe<Types.ContactDataInput>;
  sub1?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetFormFunnelMatchesQuery = { __typename?: 'Query', getFormFunnelMatches: { __typename?: 'FormFunnelMatchResult', scenario: Types.FormFunnelScenario, maxResults: number, redirectUrl: string | null, targetProgramId: string | null, targetProgramName: string | null, socialRedirectUrl: string | null, prePingResult: {
      [key: string]: any;
    } | null, needsContact: boolean, isErrorFallback: boolean | null, resultMatches: Array<{ __typename?: 'FormFunnelRankedMatch', rank: number, scenario: Types.FormFunnelScenario, prePingResult: {
        [key: string]: any;
      } | null, match: { __typename?: 'DreamSearchItem', id: string, distance: number, score: number, program: { __typename?: 'Program', id: string, name: string, slug: string, environment: Types.ProgramEnvironment, preLeadRedirect: string | null, preLeadRedirectParams: {
            [key: string]: any;
          } | null, preLeadRedirectCompositeParams: {
            [key: string]: any;
          } | null, preLeadRedirectSuppressDefaultParams: boolean | null, customCtaCopy: string | null, customDisclaimer: string | null, programHighlights: Array<string>, isSendingPaidLeadsEnabled: boolean, requiredFields: Array<Types.ProgramRequiredField> | null, dobFieldVisibility: Types.DobFieldVisibility, allowedZipCodes: Array<string>, hsGradYearMin: number | null, hsGradYearMax: number | null, vocation: { __typename?: 'Vocation', id: string, industry: Types.VocationIndustry }, paymentOptions: Array<{ __typename?: 'PaymentOption', id: string, isActive: boolean }> }, provider: { __typename?: 'Provider', id: string, fullName: string, shortName: string, advertiserName: string | null, slug: string, isPartnered: boolean, isTrustedFormEnabled: boolean, successPageMessage: string | null, logoImageFile: { __typename?: 'ImageFile', url: string | null } | null } } }>, topMatch: { __typename?: 'DreamSearchItem', id: string, distance: number, score: number, program: { __typename?: 'Program', id: string, name: string, slug: string, environment: Types.ProgramEnvironment, preLeadRedirect: string | null, preLeadRedirectParams: {
          [key: string]: any;
        } | null, preLeadRedirectCompositeParams: {
          [key: string]: any;
        } | null, preLeadRedirectSuppressDefaultParams: boolean | null, customCtaCopy: string | null, customDisclaimer: string | null, programHighlights: Array<string>, isSendingPaidLeadsEnabled: boolean, requiredFields: Array<Types.ProgramRequiredField> | null, dobFieldVisibility: Types.DobFieldVisibility, allowedZipCodes: Array<string>, hsGradYearMin: number | null, hsGradYearMax: number | null, vocation: { __typename?: 'Vocation', id: string, industry: Types.VocationIndustry }, paymentOptions: Array<{ __typename?: 'PaymentOption', id: string, isActive: boolean }> }, provider: { __typename?: 'Provider', id: string, fullName: string, shortName: string, advertiserName: string | null, slug: string, isPartnered: boolean, isTrustedFormEnabled: boolean, successPageMessage: string | null, logoImageFile: { __typename?: 'ImageFile', url: string | null } | null } } | null, matches: Array<{ __typename?: 'DreamSearchItem', id: string, distance: number, favorited: boolean, score: number, program: { __typename?: 'Program', id: string, name: string, slug: string }, provider: { __typename?: 'Provider', id: string, fullName: string, slug: string, logoImageFile: { __typename?: 'ImageFile', url: string | null } | null } }> } | null };

export type GetFormFunnelAvailableConcentrationsQueryVariables = Types.Exact<{
  funnelId: Types.Scalars['ID']['input'];
  answers: Types.Scalars['Json']['input'];
  geo: Types.DreamSearchGeo;
}>;


export type GetFormFunnelAvailableConcentrationsQuery = { __typename?: 'Query', getFormFunnelAvailableConcentrations: { __typename?: 'FormFunnelAvailableConcentrationsResult', subindustries: Array<Types.VocationSubindustry>, vocationIds: Array<string> } };

export type SubmitFormFunnelLeadMutationVariables = Types.Exact<{
  funnelId: Types.Scalars['ID']['input'];
  programId: Types.Scalars['ID']['input'];
  answers: Types.Scalars['Json']['input'];
  formFunnelSessionId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  customerData?: Types.InputMaybe<Types.CustomerFormDataInput>;
  complianceTracking: Types.ComplianceTrackingDataInput;
  utmTracking?: Types.InputMaybe<Types.TrackingDataInput>;
  disclaimer?: Types.InputMaybe<Types.Scalars['String']['input']>;
  geo?: Types.InputMaybe<Types.DreamSearchGeo>;
  prePingResult?: Types.InputMaybe<Types.Scalars['Json']['input']>;
  selectedResultRank?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type SubmitFormFunnelLeadMutation = { __typename?: 'Mutation', submitFormFunnelLead: { __typename?: 'FormFunnelLeadResult', success: boolean, enrollmentItemId: string | null, scenario: Types.FormFunnelScenario, redirectUrl: string | null, customerId: string | null, marketplaceEventId: string | null, everflowTransactionId: string | null, eligibilityFailure: string | null } | null };

export type SaveFormFunnelSessionAnswersMutationVariables = Types.Exact<{
  sessionId: Types.Scalars['ID']['input'];
  funnelId: Types.Scalars['ID']['input'];
  answers: Types.Scalars['Json']['input'];
}>;


export type SaveFormFunnelSessionAnswersMutation = { __typename?: 'Mutation', saveFormFunnelSessionAnswers: { __typename?: 'CustomerFormFunnelSession', id: string } };


export const FormFunnelDocument = gql`
    query formFunnel($slug: String!) {
  getFormFunnelConfig(slug: $slug) {
    id
    slug
    name
    meta {
      title
      description
    }
    questions {
      id
      slug
      label
      type
      options {
        label
        value
        icon
      }
      required
      conditionalLogic
    }
  }
}
    ` as unknown as DocumentNode<FormFunnelQuery, FormFunnelQueryVariables>;
export const GetFormFunnelMatchesDocument = gql`
    query getFormFunnelMatches($funnelId: ID!, $answers: Json!, $geo: DreamSearchGeo!, $jornayaLeadId: String, $contactData: ContactDataInput, $sub1: String) {
  getFormFunnelMatches(
    funnelId: $funnelId
    answers: $answers
    geo: $geo
    jornayaLeadId: $jornayaLeadId
    contactData: $contactData
    sub1: $sub1
  ) {
    scenario
    maxResults
    redirectUrl
    targetProgramId
    targetProgramName
    socialRedirectUrl
    prePingResult
    needsContact
    isErrorFallback
    resultMatches {
      rank
      scenario
      prePingResult
      match {
        id
        distance
        score
        program {
          id
          name
          slug
          environment
          preLeadRedirect
          preLeadRedirectParams
          preLeadRedirectCompositeParams
          preLeadRedirectSuppressDefaultParams
          customCtaCopy
          customDisclaimer
          programHighlights
          isSendingPaidLeadsEnabled
          requiredFields
          dobFieldVisibility
          allowedZipCodes
          hsGradYearMin
          hsGradYearMax
          vocation {
            id
            industry
          }
          paymentOptions(filter: {type: SCHOOL_FINANCIAL_AID, isVisible: true}) {
            id
            isActive
          }
        }
        provider {
          id
          fullName
          shortName
          advertiserName
          slug
          isPartnered
          isTrustedFormEnabled
          successPageMessage
          logoImageFile {
            url
          }
        }
      }
    }
    topMatch {
      id
      distance
      score
      program {
        id
        name
        slug
        environment
        preLeadRedirect
        preLeadRedirectParams
        preLeadRedirectCompositeParams
        preLeadRedirectSuppressDefaultParams
        customCtaCopy
        customDisclaimer
        programHighlights
        isSendingPaidLeadsEnabled
        requiredFields
        dobFieldVisibility
        allowedZipCodes
        hsGradYearMin
        hsGradYearMax
        vocation {
          id
          industry
        }
        paymentOptions(filter: {type: SCHOOL_FINANCIAL_AID, isVisible: true}) {
          id
          isActive
        }
      }
      provider {
        id
        fullName
        shortName
        advertiserName
        slug
        isPartnered
        isTrustedFormEnabled
        successPageMessage
        logoImageFile {
          url
        }
      }
    }
    matches {
      id
      distance
      favorited
      score
      program {
        id
        name
        slug
      }
      provider {
        id
        fullName
        slug
        logoImageFile {
          url
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<GetFormFunnelMatchesQuery, GetFormFunnelMatchesQueryVariables>;
export const GetFormFunnelAvailableConcentrationsDocument = gql`
    query getFormFunnelAvailableConcentrations($funnelId: ID!, $answers: Json!, $geo: DreamSearchGeo!) {
  getFormFunnelAvailableConcentrations(
    funnelId: $funnelId
    answers: $answers
    geo: $geo
  ) {
    subindustries
    vocationIds
  }
}
    ` as unknown as DocumentNode<GetFormFunnelAvailableConcentrationsQuery, GetFormFunnelAvailableConcentrationsQueryVariables>;
export const SubmitFormFunnelLeadDocument = gql`
    mutation submitFormFunnelLead($funnelId: ID!, $programId: ID!, $answers: Json!, $formFunnelSessionId: ID, $customerData: CustomerFormDataInput, $complianceTracking: ComplianceTrackingDataInput!, $utmTracking: TrackingDataInput, $disclaimer: String, $geo: DreamSearchGeo, $prePingResult: Json, $selectedResultRank: Int) {
  submitFormFunnelLead(
    funnelId: $funnelId
    programId: $programId
    answers: $answers
    formFunnelSessionId: $formFunnelSessionId
    customerData: $customerData
    complianceTracking: $complianceTracking
    utmTracking: $utmTracking
    disclaimer: $disclaimer
    geo: $geo
    prePingResult: $prePingResult
    selectedResultRank: $selectedResultRank
  ) {
    success
    enrollmentItemId
    scenario
    redirectUrl
    customerId
    marketplaceEventId
    everflowTransactionId
    eligibilityFailure
  }
}
    ` as unknown as DocumentNode<SubmitFormFunnelLeadMutation, SubmitFormFunnelLeadMutationVariables>;
export const SaveFormFunnelSessionAnswersDocument = gql`
    mutation saveFormFunnelSessionAnswers($sessionId: ID!, $funnelId: ID!, $answers: Json!) {
  saveFormFunnelSessionAnswers(
    sessionId: $sessionId
    funnelId: $funnelId
    answers: $answers
  ) {
    id
  }
}
    ` as unknown as DocumentNode<SaveFormFunnelSessionAnswersMutation, SaveFormFunnelSessionAnswersMutationVariables>;